// Carry Roll Result slice — memoized derived FlightResult. The SOLE engine invocation site.

import type { StateCreator } from 'zustand';
import { simulate } from '@carry-roll/shared-logic';
import type { FlightResult, SimulationRequest } from '@carry-roll/shared-types';
import { DEFAULT_DRIVER_REQUEST } from '@carry-roll/shared-logic';

export interface ResultSlice {
  result: FlightResult;
  stale: boolean;
  recompute: (request: SimulationRequest) => void;
}

// Module-level cache so recompute only runs when request identity changes (NFR-4 determinism).
let cachedRequest: SimulationRequest | null = null;
let cachedResult: FlightResult | null = null;

export function computeResult(request: SimulationRequest): FlightResult {
  if (cachedRequest === request && cachedResult) {
    return cachedResult;
  }
  cachedRequest = request;
  cachedResult = simulate(request);
  return cachedResult;
}

const initialRequest: SimulationRequest = structuredClone(DEFAULT_DRIVER_REQUEST);
cachedRequest = initialRequest;
cachedResult = simulate(initialRequest);

export const createResultSlice: StateCreator<ResultSlice, [], [], ResultSlice> = (set) => ({
  result: cachedResult!,
  stale: false,
  recompute: (request) => {
    set({ stale: true });
    const result = computeResult(request);
    set({ result, stale: false });
  },
});
